import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {getProducts, getFilterProducts} from "../../../redux/actions/product";
import {Grid,Col} from "react-bootstrap";
import EquivalenceForm from "./EquivalenceForm";

class Equivalence extends Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.selectedProduct = null;
        this.state = {
            nom: '',
            DCI: '',
            classesPharmacologiques: '',
            familleTherapeutique: '',
            dosage: '',
            forme: '',
        };
    }

    onChangeProduct = product => {
        this.selectedProduct = product;
        this.setState({
            DCI: product.DCI,
            forme: product.forme,
            dosage: product.dosage
        });
    }

    onSubmit(event) {
            event.preventDefault();

            if(this.selectedProduct != null) {   
                // RETOUR À LA LOGIQUE ORIGINALE
                this.props.getFilterProducts(this.selectedProduct);  
            } 
            else {
                return null;
            }
    }
     
    render() {
        return (
            <div>
                <Grid fluid>
                    <Col sm={12}>
                        <form onSubmit={this.onSubmit}>
                            <EquivalenceForm
                                onChangeProduct = {this.onChangeProduct}
                            />
                        </form>
                    </Col>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        message: state.status.message,
        loading: state.status.loading,
        product: state.products.product,        
    }
};

const mapDispatchToProps = dispatch => ({
    getProducts: (filter, autocomplete) => {
        dispatch(getProducts(filter, autocomplete));
    },
    getFilterProducts: filter => {
        dispatch(getFilterProducts(filter));
    },
});

Equivalence.propTypes = {
    match: PropTypes.object,
    message: PropTypes.object,
    loading: PropTypes.bool,
    showNotification: PropTypes.func,
    getProductById: PropTypes.func,
    product: PropTypes.object,
    getFilterProducts: PropTypes.func,
    getProducts: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Equivalence);